
import { defineComponent } from "vue";
import WishButton from "./WishButton.vue";
import TextButton from "@/components/shared/TextButton.vue";
import GemCounter from "@/components/shared/GemCounter.vue";
import BannerDetailsScreen from "@/components/ScreenBannerDetails/BannerDetailsScreen.vue";
import { ItemDatabase } from "@/state/Gacha";
import { Banner, Item, Settings } from "@/types";
import Inventory from "@/state/Inventory";
import WishHistoryScreen from "@/components/ScreenWishHistory/WishHistoryScreen.vue";
import ItemDescriptionOverlay from "@/components/overlays/ItemDescriptionOverlay.vue";
import CloseButton from "@/components/shared/CloseButton.vue";
import SettingsScreen from "../ScreenSettings/SettingsScreen.vue";

export default defineComponent({
  components: {
    WishButton,
    TextButton,
    GemCounter,
    BannerDetailsScreen,
    WishHistoryScreen,
    ItemDescriptionOverlay,
    CloseButton,
    SettingsScreen,
  },
  props: {
    banners: {
      type: Object as () => Banner[],
      required: true,
    },
    currentBannerIndex: {
      type: Number,
      required: true,
    },
    inventory: {
      type: Inventory,
      required: true,
    },
  },
  emits: ["wish", "go-quests", "go-shop", "change-banner"],
  data() {
    return {
      showDetails: false,
      showHistory: false,
      showSettings: false,
      activeItemId: "",
      targetExitEmit: "" as "wish" | "go-quests" | "go-shop" | "",
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    banner(): Banner {
      return this.banners[this.currentBannerIndex];
    },
    activeItem(): Item {
      return ItemDatabase[this.activeItemId];
    },
    stateExiting(): boolean {
      return this.targetExitEmit !== "";
    },
    isMobile(): boolean {
      return (
        (this.windowHeight > this.windowWidth && this.windowWidth < 850) ||
        this.windowHeight < 700
      );
    },
    settings(): Settings {
      return this.$store.state.settings;
    },
  },
  created() {
    this.$nextTick(() => window.addEventListener("resize", this.onResize));
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    getBannerHeaderImage(banner: Banner, selected = false): string {
      const images = require.context(
        "@/assets/images/banner-headers/",
        false,
        /\.webp$/
      );
      try {
        return images(`./${selected ? "selected-" : ""}${banner.id}.webp`);
      } catch (error) {
        return `./${selected ? "selected-" : ""}${banner.id}.webp`;
      }
    },
    wish(number: number): void {
      this.$emit("wish", number, this.banner.storage === "standard");
    },
    changeBanner(index: number): void {
      (
        document.getElementById("audio-banner-switch") as HTMLAudioElement
      ).play();
      this.$emit("change-banner", index);
    },
    exitDetailsScreen(): void {
      (
        document.getElementById("audioExitDialogDEPRECATED") as HTMLAudioElement
      ).play();
      this.showDetails = false;
    },
    exitHistoryScreen(): void {
      // so much legacy cruft from when I didn't know Vue :(
      (
        document.getElementById("audioExitDialogDEPRECATED") as HTMLAudioElement
      ).play();
      this.showHistory = false;
    },
    exitSettingsScreen(): void {
      // AAAAAAAAAAA
      // imagine adding new features instead of cleaning up legacy cruft
      (
        document.getElementById("audioExitDialogDEPRECATED") as HTMLAudioElement
      ).play();
      if (
        !this.$store.state.settings.everythingBanner &&
        this.banner.id === "everything"
      ) {
        this.$emit("change-banner", 0);
      }
      this.showSettings = false;
    },
    exitEmit(): void {
      if (!this.targetExitEmit) {
        // i would use this.stateExiting but typescript needs
        // to check that and isn't smart enough to do that :(
        return;
      }
      this.$emit(this.targetExitEmit);
    },
    exit(): void {
      this.$emit("go-quests");
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    },
  },
});
